import React, { useState, useEffect } from 'react';
import categoryService from '../../services/CategoryService';
import SlideAdd from '../../components/material/SlideAddMat';
import SlideEdit from '../../components/material/SlideEditMat';
import Nav from '../../components/material/NavMaterial';
import "../../static/css/breadcrumb.css";
import defaultMaterial from '../../static/images/img_default_material.webp';

const BASE_URL = process.env.REACT_APP_API_ENDPOINT;

export default function Material({ itemsPerPage = 20 }) {
    const [loading, setLoading] = useState(true);
    const [breadcrumb, setBreadcrumb] = useState([]);
    const [showMat, setShowMat] = useState(false);
    const [viewMat, setViewMat] = useState("Scheda");
    const [material, setMaterial] = useState(null);
    const [isSlideOpen, setIsSlideOpen] = useState(false);
    const [isSlideOpenEdit, setIsSlideOpenEdit] = useState(false);
    const [idCategory, setIdCategory] = useState(null);
    const [nameCategory, setNameCategory] = useState(null);
    const [results, setResults] = useState([]);
    const [resultsMat, setResultsMat] = useState([]);
    const [totalResults, setTotalResults] = useState(0);
    const [totalResMat, setTotalResMat] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageMat, setCurrentPageMat] = useState(1);
    const [itemsPerPageLocal, setItemsPerPageLocal] = useState(itemsPerPage);
    const [itemsPerPageLocalMat, setItemsPerPageLocalMat] = useState(itemsPerPage);
    const [openAction, setOpenAction] = useState(null);
    const [position, setPosition] = useState({ x: 0, y: 0 });

    const totalPages = Math.ceil(results.length / itemsPerPageLocal);
    const startIndex = (currentPage - 1) * itemsPerPageLocal;
    const endIndex = startIndex + itemsPerPageLocal;
    const currentItems = results.slice(startIndex, endIndex);
    const totPagesMat = Math.ceil(resultsMat.length / itemsPerPageLocalMat);
    const startIndexMat = (currentPage - 1) * itemsPerPageLocalMat;
    const endIndexMat = startIndexMat + itemsPerPageLocalMat;
    const currentItemsMat = resultsMat.slice(startIndexMat, endIndexMat);

    const goToPage = (page) => {
        setCurrentPage(page);
    };

    const fetchCategory= async () => {
        try {
            const res = await categoryService.getRootAll();
            const resultsData = res.data || [];
            const total = res.data.length || 0;

            setResults(resultsData); // Salva i risultati
            setTotalResults(total); // Salva il totale dei risultati
            setCurrentPage(1);
            setLoading(false);
            setShowMat(false);
            // Calcoliamo dinamicamente itemsPerPageLocal dopo aver ricevuto i dati
            const defaultItemsPerPage = Math.min(itemsPerPage, total);
            setItemsPerPageLocal(defaultItemsPerPage);

        } catch (error) {
            console.error('Error fetching clients', error);
        }
    };

    useEffect(() => {
        fetchCategory();
    }, []);

    const fetchCategoryMaterials = async (categoryId) => {
        try {
            const resMat = await categoryService.getMaterialsAll(categoryId);
            const resultsDataMat = resMat.data || [];
            const totalMat = resMat.data.length || 0;

            setResultsMat(resultsDataMat); // Salva i risultati
            setTotalResMat(totalMat); // Salva il totale dei risultati
            setCurrentPageMat(1);
            setLoading(false);
            setShowMat(true);
            // Calcoliamo dinamicamente itemsPerPageLocal dopo aver ricevuto i dati
            const defItemsPerPageMat = Math.min(itemsPerPage, totalMat);
            setItemsPerPageLocalMat(defItemsPerPageMat);

        } catch (error) {
            console.error('Error fetching clients', error);
        }
    };

    const fetchCategoryChildren = async (category) => {
        try {
            setIdCategory(category.id_category);
            setNameCategory(category.name);
            setBreadcrumb(prev => {
                if (prev.find(cat => cat.id_category === category.id_category)) {
                    return prev;
                }
                return [...prev, category];
            });
            setViewMat(category.view);
            fetchCategoryMaterials(category.id_category);
            const res = await categoryService.getChildrenAll(category.id_category);
            const resultsData = res.data || [];
            const total = res.data.length || 0;

            setResults(resultsData); // Salva i risultati
            setTotalResults(total); // Salva il totale dei risultati
            setCurrentPage(1);
            setLoading(false);
            // Calcoliamo dinamicamente itemsPerPageLocal dopo aver ricevuto i dati
            const defaultItemsPerPage = Math.min(itemsPerPage, total);
            setItemsPerPageLocal(defaultItemsPerPage);

        } catch (error) {
            console.error('Error fetching clients', error);
        }
    };

    const handleBreadcrumbClickRoot = () => {
        fetchCategory();
        setBreadcrumb([]);
        setResults([]);
        setResultsMat([]);
    };

    const handleBreadcrumbClick = (index) => {
        const categoryToDisplay = breadcrumb[index];
        if (results.find(cat => cat.id_category === categoryToDisplay.id_category)) {
            return;
        }
        setBreadcrumb(breadcrumb.slice(0, index + 1)); // Mantieni solo fino alla categoria selezionata
        fetchCategoryChildren(categoryToDisplay);
    };

    const toggleSlide = () => {
        setIsSlideOpen(!isSlideOpen);
    };

    const toggleSlideEdit = (material) => {
        setMaterial(material);
        setIsSlideOpenEdit(!isSlideOpenEdit);
    };

    const handleActionClick = (index,e) => {
        const rect = e.target.getBoundingClientRect();
        const offsetX = e.clientX - rect.left;
        const offsetY = e.clientY - rect.top;
        const adjustedX = offsetX - 80;
        const adjustedY = offsetY - 10;

        setPosition((prevPositions) => ({
              ...prevPositions,
              [index]: { x: adjustedX, y: adjustedY }, // Imposta la posizione dell'elemento
            }));
        setOpenAction(openAction === index ? null : index);
    };

  	return (
  	<>
        <div className="row">
            <div className="col-md-12">
                {/* Nav Material */}
                <Nav />
            </div>
            <div className="row text-nowrap">
                {breadcrumb.length > 0 && (
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb breadcrumb-style1">
                        <li className="breadcrumb-item">
                            <a onClick={() => handleBreadcrumbClickRoot()}>Elenco</a>
                        </li>
                        {breadcrumb.map((category, index) => (
                          <li className="breadcrumb-item" key={category.id}>
                            <a onClick={() => handleBreadcrumbClick(index)}>{category.name}</a>
                          </li>
                        ))}
                        {/* <li className="breadcrumb-item active">Data</li> */}
                    </ol>
                </nav>
                )}
                {currentItems.map((result,index) => (
                <div className="col-md-2 mb-6" key={result.id_category}>
                    <div className="card h-100">
                        <div className="card-body">
                            <div className="card-info">
                                <h5 onClick={() => fetchCategoryChildren(result)} className="card-title mb-2 cursor-link truncate" title={result.name}>{result.name}</h5>
                                {/* <a href=""><span>Modifica</span></a>  */}
                            </div>
                        </div>
                    </div>
                </div>
                ))}
            </div>
            {showMat && viewMat === "Scheda" && (
            <>
            <div className="row text-nowrap">
                <div className="col-md-12 mb-6">
                    <div className="card card-action">
                        <div className="card-header align-items-center">
                            <h5 className="card-action-title mb-0">Elenco Materiali: {nameCategory}</h5>
                            <div className="card-action-element">
                                <button onClick={() => toggleSlide()} className="btn btn-primary btn-sm edit-address" type="button">
                                    <i className="bx bx-plus bx-xs me-1_5"></i>Aggiungi
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {currentItemsMat.map((resultsMat,index) => (
                <div className="col-md-3 mb-2" key={resultsMat.id_material}>
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title truncate" title={resultsMat.name} >{resultsMat.name}</h5>
                            <h6 className="card-subtitle">Dimensioni: {resultsMat.dimensions ? resultsMat.dimensions : "Non inserita"}</h6>
                            <img className="img-fluid d-flex mx-auto my-6 rounded" src={ resultsMat.pathImg ? `${BASE_URL}/${resultsMat.pathImg}`: defaultMaterial } alt="Card image cap"/>
                            <p className="card-text">{resultsMat.note ? resultsMat.note : "Nessuna nota inserita"}</p>
                            <p className="card-text"><small className="text-muted">Quantità: {resultsMat.amount}</small></p>
                            <a className="card-link" onClick={() => toggleSlideEdit(resultsMat)}>Modifica</a>
                            <a className="card-link">Ordina</a>
                        </div>
                    </div>
                </div>
                ))}
            </div>
            <div className="row">
                <div className="col-sm-12 col-md-6">
                    <div className="dataTables_info" role="status" aria-live="polite">
                        Risultati ottenuti : {totalResMat}
                    </div>
                </div>
                {totalResMat != 0 &&
                <div className="col-sm-12 col-md-6">
                    <div className="dataTables_paginate paging_simple_numbers custom-ryo">
                        {!loading && (
                            <div className="pagination">
                                <button className="page-link" onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
                                    <i className="bx bx-chevron-left bx-18px"></i>
                                </button>
                                {Array.from({ length: totPagesMat }, (_, index) => (
                                    <button
                                      key={index + 1}
                                      onClick={() => goToPage(index + 1)}
                                      disabled={currentPage === index + 1}
                                      className={`page-link ${currentPage === index + 1  ? "current-page" : ""}`}
                                    >
                                      {index + 1}
                                    </button>
                                ))}
                                <button className="page-link" onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totPagesMat}>
                                    <i className="bx bx-chevron-right bx-18px"></i>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                }
            </div>
            </>
            )}
            {/* Slide */}
            { idCategory && nameCategory && (
                <SlideAdd
                    show={isSlideOpen}
                    onClose={toggleSlide}
                    onFetchMaterials={fetchCategoryMaterials}
                    idCategory={idCategory}
                    nameCategory={nameCategory}
                />
              )
            }
            { material && (
                <SlideEdit
                    show={isSlideOpenEdit}
                    onClose={toggleSlideEdit}
                    onFetchMaterials={fetchCategoryMaterials}
                    material={material}
                    idCategory={idCategory}
                />
                )
            }
            {/* Slide */}
        </div>
        {showMat && viewMat === "Elenco" && (
        <div className="row text-nowrap">
            <div className="col-md-12">
                <div className="card card-action">
                    <div className="card-header align-items-center">
                        <h5 className="card-action-title mb-0">Elenco Materiali: {nameCategory}</h5>
                        <div className="card-action-element">
                            <button onClick={() => toggleSlide()} className="btn btn-primary btn-sm edit-address" type="button">
                                <i className="bx bx-plus bx-xs me-1_5"></i>Aggiungi
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )}
        {totalResMat === 0 && viewMat === "Elenco" && (
        <div className="row">
            <div className="col-sm-12 col-md-6 mt-6">
                <div className="dataTables_info" role="status" aria-live="polite">
                    Risultati ottenuti : {totalResMat}
                </div>
            </div>
        </div>
        )}
        {totalResMat != 0 && showMat && viewMat === "Elenco" && (
        <>
        <div className="card">
            <div className="card-datatable table-responsive">
                <div className="dataTables_wrapper dt-bootstrap5 no-footer">
                    <table className="datatables-users table border-top dataTable no-footer dtr-column">
                        <thead>
                            <tr>
                                <th>NOME</th>
                                <th>Q.TA</th>
                                <th>DIMENSIONE</th>
                                <th>DESCRIZIONE</th>
                                <th>NOTA</th>
                                <th>AZIONI</th>
                            </tr>
                        </thead>
                        {loading && (
                        <tbody>
                            <tr className="odd">
                                <td className="dataTables_empty">Loading...</td>
                            </tr>
                        </tbody>
                        )}
                        <tbody>
                         {currentItemsMat.map((resultsMat,index) => (
                            <tr key={resultsMat.id_material}>
                                <td>{resultsMat.name}</td>
                                <td>{resultsMat.amount}</td>
                                <td>{resultsMat.dimensions}</td>
                                <td>{resultsMat.description}</td>
                                <td>{resultsMat.note}</td>
                                <td>
                                    <div className="dropdown">
                                        <button type="button" className="btn p-0" onClick={(e) => handleActionClick(index,e)}>
                                            <i className="bx bx-dots-vertical-rounded"></i>
                                        </button>
                                        <div className={`dropdown-menu ${openAction === index ? "show-action" : ""}`}
                                            style={{
                                                position: 'absolute',
                                                transform: position[index]
                                                    ? `translate3d(${position[index].x}px, ${position[index].y}px, 0px)`
                                                    : 'translate3d(0px, 0px, 0px)',
                                                transition: 'transform 0.3s ease',
                                            }}
                                        >
                                        <a className="dropdown-item" onClick={() => toggleSlideEdit(resultsMat)}>
                                            <i className="bx bx-edit-alt me-1"></i>Modifica
                                        </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                          ))}
                        </tbody>
                    </table>
                    <div className="row">
                        <div className="col-sm-12 col-md-6">
                            <div className="dataTables_info" role="status" aria-live="polite">
                                Risultati ottenuti : {totalResMat}
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6">
                            <div className="dataTables_paginate paging_simple_numbers custom-ryo">
                                {!loading && (
                                    <div className="pagination">
                                        <button className="page-link" onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
                                            <i className="bx bx-chevron-left bx-18px"></i>
                                        </button>
                                        {Array.from({ length: totPagesMat }, (_, index) => (
                                            <button
                                              key={index + 1}
                                              onClick={() => goToPage(index + 1)}
                                              disabled={currentPage === index + 1}
                                              className={`page-link ${currentPage === index + 1  ? "current-page" : ""}`}
                                            >
                                              {index + 1}
                                            </button>
                                        ))}
                                        <button className="page-link" onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totPagesMat}>
                                            <i className="bx bx-chevron-right bx-18px"></i>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
        )}
  	</>
	);
}